import { createRouter, createWebHashHistory } from 'vue-router'
import { isVisitorNoticeOkInSession, getHostCompanyFromSession } from '../utils/visitorNotice'

const routes = [
  {
    path: '/',
    name: 'CompanySelect',
    component: () => import('../views/CompanySelectView.vue'),
    meta: {
      title: '选择访问公司'
    }
  },
  {
    path: '/notice',
    name: 'Notice',
    component: () => import('../views/NoticeView.vue'),
    meta: {
      title: '入厂须知',
      requireHostCompany: true
    }
  },
  {
    path: '/register',
    name: 'Register',
    component: () => import('../views/RegisterView.vue'),
    meta: {
      title: '访客登记',
      requireVisitorNotice: true
    }
  },
  {
    path: '/auth-callback',
    name: 'AuthCallback',
    component: () => import('../views/AuthCallback.vue'),
    meta: {
      title: '授权处理'
    }
  },
  {
    path: '/success',
    name: 'Success',
    component: () => import('../views/SuccessView.vue'),
    meta: {
      title: '提交成功'
    }
  }
]

const router = createRouter({
  history: createWebHashHistory(process.env.BASE_URL),
  routes
})

router.beforeEach((to, from, next) => {
  if (to.meta && to.meta.title) {
    document.title = to.meta.title
  }
  if (to.meta && to.meta.requireHostCompany && !getHostCompanyFromSession()) {
    next({ path: '/', replace: true })
    return
  }
  if (to.meta && to.meta.requireVisitorNotice) {
    if (!getHostCompanyFromSession()) {
      next({ path: '/', replace: true })
      return
    }
    if (!isVisitorNoticeOkInSession()) {
      next({ path: '/notice', replace: true })
      return
    }
  }
  next()
})

export default router
